import { atom } from "recoil";

export interface ISessionLineOfBusiness {
  id: string;
  name: string;
  isSelected: boolean;
}

export const linesOfBusinessState = atom<ISessionLineOfBusiness[]>({
  key: "linesOfBusinessState",
  default: [],
});
